// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants

const configs = {
	"development": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_qbczWiAF6',
        'aws_user_pools_web_client_id': '7k9lsjdqes2nvdtu05nbv3v3nv'
	},
	"staging": {
		'aws_user_pools': 'enable',
		'aws_user_pools_id': 'eu-west-1_852HA2j9Z',
		'aws_user_pools_web_client_id': '7k1s4jjtah85m759oujtcimaar'
	},
	"demo": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_gZmy0meth',
        'aws_user_pools_web_client_id': '5p9v6fl7pp4pfum3gcaad87vkr'
	},
    "stresidences": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_rP650z5rG',
        'aws_user_pools_web_client_id': '7r37r3hbp751tq7gr3mrbs1ba2'
    },
    "escape2thesands": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_9Q7kVTltv',
        'aws_user_pools_web_client_id': '4f0bqn94b22ru6jj7ehbsdasoq'
    },
	"youarehome": {
		'aws_user_pools': 'enable',
		'aws_user_pools_id': 'eu-west-1_vhXAMcYKI',
		'aws_user_pools_web_client_id': '7u6q3hdhjv7pi6i1t952qga9j6'
	},
    "ldg": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_Kvq6tvygp',
        'aws_user_pools_web_client_id': '5g8jalk4ahdvq8tv7fp3fm8adb'
    },
	"clarendon": {
		'aws_user_pools': 'enable',
		'aws_user_pools_id': 'eu-west-1_GkMhWf4qE',
		'aws_user_pools_web_client_id': '4o9qdctdlbsfe216lsqiopc3ku'
	},
    "signetapartments": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_TP7ZU04an',
        'aws_user_pools_web_client_id': '2lqi8uesp2or2fqim27unr9b50'
    },
    "charmstay": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_a6tFWPHxS',
        'aws_user_pools_web_client_id': 'fko8ud3fenr7iqlaed9m50kae'
    },
    "cosmopolitanapartments": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_W7LScftGR',
        'aws_user_pools_web_client_id': '2kjofsm86dsbm5lmvq50u40v8b'
    },
    "citystayapartment": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_NmWNG7tCT',
        'aws_user_pools_web_client_id': '31u3gv37elstqs09pm5v4mqo5j'
    },
    "roomspace": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_rrsmMIRK1',
        'aws_user_pools_web_client_id': '6a949th8pa8aqqiuofqmgrmg00'
    },
    "harrogateapartments": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_1Zl5tMpAB',
        'aws_user_pools_web_client_id': '7t2i8frdp6gpoun5onqgfjd72a'
    },
    "tempstay": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_vVn8b1wMH',
        'aws_user_pools_web_client_id': '2kll5vmciajsgm1a50395ae6ph'
    },
    "kepplestonemanor": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_ymp6tE6Gb',
        'aws_user_pools_web_client_id': '4mpibii1rbg5r645ob7djrbnha'
    },
    "scandik": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_ms8yhoKbc',
        'aws_user_pools_web_client_id': '3tgg3826nmvjffl59n7u0aqqce'
    },
    "bnbme": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_yhVNaxu0s',
        'aws_user_pools_web_client_id': '3ms6jomuo884pbva4ji7f5mkc8'
    },
    "multicurrencytest": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_9C7SqAKtU',
        'aws_user_pools_web_client_id': '7elfo3t9b8l9th3am8kjcobekk'
    },
    "tjpad": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_JS7vrbgSp',
        'aws_user_pools_web_client_id': 'dgotfr0vhu3m7butctbv8au56'
    },
    "flyingbutler": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_T7AnndF45',
        'aws_user_pools_web_client_id': '3cbbk70d5irs70cqp5dclseq40'
    },
    "sixstays": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_HTH5ENSKO',
        'aws_user_pools_web_client_id': '1dc211tnv7865f07fv56kcd89v'
    },
    "zomelle": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_Bd91LpO3I',
        'aws_user_pools_web_client_id': '58uhere4o7rv2eq9lajtn46152'
    },
    "buckinghamandlloyds": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_IA2gcvXmj',
        'aws_user_pools_web_client_id': '4io4mvhiucj1tqopko83tk9bnl'
    },
    "domusstay": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_RCuM5989d',
        'aws_user_pools_web_client_id': '1o8vo5edgnbsg76jmhk0el53qu'
    },
    "qapartments": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_klKLSc2mq',
        'aws_user_pools_web_client_id': 'ht4chcdjo19hvj0m5h4cff9fb'
    },
    "markeygroup": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_3JODPTZtA',
        'aws_user_pools_web_client_id': '59tdvgbfi0vqjrgbit3tgvjn8q'
    },
    "multicurrencytest2": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_2TjW7Sf5t',
        'aws_user_pools_web_client_id': 'ku6cuf69p0j70g27k76gq5sfb'
    },
    "mabaat": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_pb84qpUwu',
        'aws_user_pools_web_client_id': '2ildud1karohoh6o7uveuss24a'
    },
    "week2week": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_SGTpmjufM',
        'aws_user_pools_web_client_id': '455ncfdfld2cr1ek1ejlgovsqg'
    },
    "homenhancement": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_xdss8u3j1',
        'aws_user_pools_web_client_id': '92iosg6gurmteuvf1b559i36c'
    },
    "thecollectivelive": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_2r2iE3HQT',
        'aws_user_pools_web_client_id': '5eb9vrnrdnhfgqi5vg0vboojb0'
    },
    "thecollective": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_znlklPBUg',
        'aws_user_pools_web_client_id': '6tau37o8v79bt7bulck3i22h47'
    },
    "citywestaparthotel": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_1HG1Qg6H2',
        'aws_user_pools_web_client_id': 'p3f5tdnu8m27fgne5huksn62b'
    },
    "khhomes": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_6f9Umew0c',
        'aws_user_pools_web_client_id': '47hrbfbkc076ueqn8ug0dm7ajp'
    },
    "basilstreetapartments": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_Tda7xNEly',
        'aws_user_pools_web_client_id': '95eam5p4384qfin6m615rq05s'
    },
    "homa": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_7o2TQ1VXV',
        'aws_user_pools_web_client_id': '1bcdh1tl3o66o8iilqbdbdt471'
    },
    "noonsg": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_OpI90vlaM',
        'aws_user_pools_web_client_id': 'v6slevch3848fgo1gci6kou12'
    },
    "briscoeandshaw": {
        'aws_user_pools': 'enable',
        'aws_user_pools_id': 'eu-west-1_7T27Hn6AO',
        'aws_user_pools_web_client_id': '5gigjdip6qvj0fholi0fvugdar'
    }
};

export default function (env) {
    if(configs[env] !== undefined) {
        return configs[env];
    }
	return configs.development;
}
